import React, { useEffect, useState } from 'react';
import { ActivityIndicator, View } from 'react-native';
import { Button, Text } from '~/components';

import * as yup from 'yup';
import useAppNavigation from '~/hooks/useAppNavigation';
import colors from '~/assets/themes/colors';
import { useCreateAccountForm } from '~/stores';
import { createAccountUseCase } from '~/useCases/HybrisAuthenticateUseCases/CreateAccountUseCase';
import SignInUseCase from '~/useCases/HybrisAuthenticateUseCases/SignInUseCase';

export const schema = yup
  .object()
  .shape({
    password: yup
      .string()
      .min(6, 'A senha deve ter pelo menos 6 dígitos.')
      .required('A senha é obrigatória.'),
    confirmPassword: yup
      .string()
      .required('Por favor, informe a senha novamente')
      .oneOf([yup.ref('password')], 'As senhas não coincidem'),
  })
  .required();

const Finish: React.FC = () => {
  const { navigate } = useAppNavigation();
  const { form } = useCreateAccountForm();

  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function createUser() {
      if (form) {
        try {
          await createAccountUseCase(form);

          setLoading(false);

          await SignInUseCase(form.email!, form.password!);

          setTimeout(async () => {
            navigate('MarisaServicos_Home');
          }, 500);
        } catch (err: any) {
          setLoading(false);
          setError(err.message);
        }
      }
    }

    createUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <View className="justify-between items-center w-[450px]">
      {loading && (
        <ActivityIndicator color={colors.primary[600]} size={'large'} />
      )}

      {!loading && !error && (
        <>
          <Text className="my-6">😉</Text>

          <Text className="text-sm text-gray-400">
            Tudo certo! Conta criada com sucesso
          </Text>

          <View className="flex-row items-center mt-10">
            <ActivityIndicator color={colors.primary[600]} />

            <Text className="text-sm text-gray-400 ml-4">
              Aguarde enquanto redirecionamos você...
            </Text>
          </View>
        </>
      )}

      {!!error && (
        <>
          <Text className="text-sm text-gray-400">
            {error}. Por favor, tente novamente.
          </Text>

          <Button
            onPress={() => navigate('MarisaServicos_CreateAccount', {})}
            className="mt-8 w-full"
          >
            Voltar
          </Button>
        </>
      )}
    </View>
  );
};

export default Finish;
